var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "k-content", attrs: { id: "scheduler-wrapper" } },
    [
      _c("div", { attrs: { id: "classes-scheduler" } }),
      _vm.$p(["ADMIN", "MANAGER", "AFFILIATE", "INSTRUCTOR"], "or") &&
      !_vm.onlyIsRecruiter &&
      _vm.isApprovedInstructor
        ? _c(
            "q-page-sticky",
            { attrs: { position: "bottom-right", offset: [18, 18] } },
            [
              _c(
                "q-fab",
                { attrs: { color: "blue", icon: "add", direction: "up" } },
                [
                  _c(
                    "q-fab-action",
                    {
                      attrs: { color: "primary", icon: "add" },
                      on: {
                        click: function($event) {
                          _vm.createClass()
                        }
                      }
                    },
                    [
                      _c(
                        "q-tooltip",
                        {
                          attrs: {
                            anchor: "center left",
                            self: "center right",
                            offset: [20, 0]
                          }
                        },
                        [_vm._v("Add Class")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "q-fab-action",
                    {
                      attrs: { color: "positive", icon: "cloud_upload" },
                      on: {
                        click: function($event) {
                          _vm.scheduleUpload()
                        }
                      }
                    },
                    [
                      _c(
                        "q-tooltip",
                        {
                          attrs: {
                            anchor: "center left",
                            self: "center right",
                            offset: [20, 0]
                          }
                        },
                        [_vm._v("Upload Schedule")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }